import { useEffect, useState } from "react";
import { serverClock } from "../lib/castSync/serverClock";
import { timelineOf } from "../lib/castSync/timeline";
import type { StreamSlot } from "../types/stream";

/** How long a cast that should play may stay silent before we offer "Tap to listen". */
export const BLOCKED_AFTER_MS = 2500;

/**
 * True when a cast that should play (`enabled`: driver bound, timeline PLAY, not playing yet) is
 * still silent BLOCKED_AFTER_MS after its scheduled start — the browser blocked autoplay. The
 * caller may also set it directly (e.g. play() rejected). `resetKey` restarts the wait (new media).
 */
export function useAutoplayBlocked(slot: StreamSlot, enabled: boolean, resetKey: string | null) {
  const [blocked, setBlocked] = useState(false);
  useEffect(() => {
    setBlocked(false);
    if (!enabled) return;
    const tl = timelineOf(slot);
    const startsIn =
      tl?.status === "PLAY" && tl.startAt != null ? Math.max(0, tl.startAt - serverClock.now()) : 0;
    const timer = setTimeout(() => setBlocked(true), BLOCKED_AFTER_MS + startsIn);
    return () => clearTimeout(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [enabled, resetKey, slot.seekTime, slot.playStartTime, slot.timelineRev]);
  return [blocked, setBlocked] as const;
}
